import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/composables/i18n';
import { TubeStatusMetrics } from '@/models/deviceStatusMetrics';
import { getStateCss } from '@/utils/color';
import { isNil } from '@/utils/misc';
import { computed } from 'vue';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'TubeStatus',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data: TubeStatusMetrics | null;
};

const { t, n } = useI18n();



const state = computed<string>(() =>
  !isNil(props.data?.last_state) ? props.data!.last_state : 'no_communication',
);

const stateStyle = computed<string>(() =>
  props.data?.last_state ? getStateCss(state.value) : '',
);

return { __sfc: true,t, n, props, state, stateStyle }
}

})